import { RouteObject } from "react-router-dom";
import { DevelopmentScheduleCostMappingPage } from "src/routes/developments/cost-mapping/DevelopmentScheduleCostMappingPage";
import { EditOptionsPage } from "src/routes/developments/plan-and-options/options/EditOptionsPage";
import { ReassignPurchaseOrdersPage } from "src/routes/developments/reassign-purchase-orders/ReassignPurchaseOrdersPage";
import { ReviewAndPublishPage } from "src/routes/developments/templates/review-and-publish/ReviewAndPublishPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import * as fullPagePaths from "src/routing/domains/developments/full-page/fullPagePaths";

/**
 * Full-page development flows under `/developments/:developmentId` (skip SideNav; keep DevelopmentLayout).
 *
 * Role: data router domain leaves. Spread directly under `DevelopmentLayout` in
 * `detail/developmentDetail.ts` — not under `ScrollableParentLayout`. These pages own scroll
 * (`EditOptionsPage` via `StepperProvider newLayout`; review/reassign via their own
 * `ScrollableParent`), matching the plan-package edit wizard and project release-to-trades.
 */
export const fullPageUnderDevelopmentRoutes: RouteObject[] = [
  { path: fullPagePaths.developmentEditOptionsRoute.path, Component: EditOptionsPage },
  { path: fullPagePaths.developmentReviewTemplatesRoute.path, Component: ReviewAndPublishPage },
  { path: `${fullPagePaths.reassignPurchaseOrdersPath}/*`, Component: ReassignPurchaseOrdersPage },
];

/**
 * Cost mapping uses a different top-level prefix (`/schedule-cost-mapping/:developmentId`).
 *
 * Role: data router domain route. Sibling of the detail shell in `developments/index.ts`.
 */
export const costMappingRoutes: RouteObject[] = [
  {
    path: fullPagePaths.costMappingRoute.path,
    Component: AppShell,
    children: [
      { Component: GlobalNavLayout, children: [{ index: true, Component: DevelopmentScheduleCostMappingPage }] },
    ],
  },
];
